import {createAction, props} from '@ngrx/store';
import {IFullTemplateField} from '../_interface/itemplate-field';

export const loadTemplateFields = createAction(
	'[Journal 📦 TemplateFields] Loaded 👍',
	props<{ templateFields: IFullTemplateField[] }>()
);

export const upsertManyTemplateFields = createAction(
	'[Journal 📦 TemplateFields] Upsert many',
	props<{ templateFields: IFullTemplateField[] }>()
);

export const getSingleTemplateField = createAction(
	'[Journal 📦 TemplateFields] Get single template field by id 👍',
	props<{ templateFieldId: string }>()
);

export const getSingleTemplateFieldSymbolDrop = createAction(
	'[Journal 📦 TemplateFields] Get single template field by id for symbol drop👍',
	props<{ templateFieldId: string }>()
);

export const loadTemplateField = createAction(
	'[Journal 📦 TemplateFields] Single template field loaded 👍',
	props<{ templateField: IFullTemplateField }>()
);
